module.exports = __webpack_public_path__ + "static/media/header-image.41053998.jpg";